
import { defineComponent } from 'vue'
import DashboardContent from '../components/DashboardContent.vue'

export default defineComponent({
  name: 'DashboardView',
  components : { DashboardContent }
})
